import React, { useEffect } from 'react'

const NumberPad = ({numberPadValue, setNumberPadValue }) => {

  const number = [
    '7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '00', '000'
  ];

  const ClearBtn = ()=>{
    setNumberPadValue(0);
    console.log('클리어 버튼', numberPadValue);
  }

  const XBtn = ()=>{
    if(numberPadValue.length === 1 || !numberPadValue ){
      setNumberPadValue(0); 
    } else {
      setNumberPadValue((prev)=>prev.slice(0, -1));
    }
    console.log(numberPadValue);
  }
  
  useEffect(()=>{
    if(numberPadValue.length > 7){
      setNumberPadValue(0);
      alert('할인 금액이 너무 큽니다 다시 지정해 주세요');
    }
  }, [numberPadValue])

  return (
    <div className='rounded-md flex flex-col gap-3'>

      <div className='grid grid-cols-2 gap-3'>
        <button className='bg-[#4E4E4E] p-2 duration-100 active:scale-110 rounded-md hover:scale-95 active:bg-[#2E2E2E]' 
        onClick={ClearBtn}>
          Clear
        </button>
        <button className='bg-[#4E4E4E] p-2 duration-100 active:scale-110 rounded-md hover:scale-95 active:bg-[#2E2E2E]' 
        onClick={XBtn}>
          X
        </button>
      </div>

      <div className='grid grid-cols-3 gap-3'>        
        {
          number.map((num, idx)=>(
            <button key={idx}
            className={`bg-[#4E4E4E] p-3 duration-100 active:scale-110 rounded-md hover:scale-95 active:bg-[#2E2E2E]`}
            onClick={()=>{
              if(numberPadValue === 0){
                setNumberPadValue('');
                setNumberPadValue((prev)=> prev + num);
              } else {
                setNumberPadValue((prev)=> prev + num);
              }
            }}>
              {num}
            </button>
          ))
        }
      </div>

    </div>
  )
}

export default NumberPad